<div class="dialog-backdrop" id="apx">
    <div class="dialog-box">
        <div class="dialog-content">
            <p class="error-message" [innerHTML]="data.errormessage"></p>
            @if (!allowClose) {
            <button (click)="onRetryClick()" apxButton>{{ 'Retry' | translate }}</button>
            }

            <div class="error-details">
                <h3 class="text-align-center">
                    <strong>{{ 'ErrorDetails' | translate }}</strong>
                </h3>
                <p>
                    <strong>{{ 'ErrorStatusCode' | translate }}:</strong>
                    {{ data.errorStatus }}
                </p>
                @if (data.orgId) {
                <p>
                    <strong>{{ 'organizationId' | translate }}:</strong>
                    {{ data.orgId }}
                </p>
                } @if (data.contractId) {
                <p>
                    <strong>{{ 'contractId' | translate }}:</strong>
                    {{ data.contractId }}
                </p>
                } @if (data.customerId) {
                <p>
                    <strong>{{ 'customerId' | translate }}:</strong>
                    {{ data.customerId }}
                </p>
                } @if (data.quickLink) {
                <p>
                    <strong>{{ 'QuickLink' | translate }}:</strong>
                    {{ data.quickLink }}
                </p>
                }
                <p>
                    <strong>{{ 'Date' | translate }}:</strong>
                    {{ data.date }}
                </p>
                @if (data.apiMessage) {
                <p class="grey">
                    <strong>{{ 'ErrorMessage' | translate }}:</strong>
                    {{ data.apiMessage }}
                </p>
                }
            </div>

            @if (allowClose) {
            <button (click)="onCloseClick()" apxButton>{{ 'Close' | translate }}</button>
            }
        </div>
    </div>
</div>
